// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_6KI","cls2":"TranslationModal-cls2_hTH TranslationModal-cls1_6KI"};